import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/download.svg'
import _imports_1 from '../../assets/resize_app/ImageApp1.png'
import _imports_2 from '../../assets/resize_app/ImageApp2.png'
import _imports_3 from '../../assets/resize_app/ImageApp3.png'
import _imports_4 from '../../assets/unzip_app/ImageApp1.png'
import _imports_5 from '../../assets/unzip_app/ImageApp2.png'
import _imports_6 from '../../assets/unzip_app/ImageApp3.png'
import _imports_7 from '../../assets/preview_app/ImageApp1.png'
import _imports_8 from '../../assets/preview_app/ImageApp2.png'
import _imports_9 from '../../assets/preview_app/ImageApp3.png'


const _withScopeId = n => (_pushScopeId("data-v-3ebf02a1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid px-5" }
const _hoisted_2 = {
  key: 0,
  class: "row mt-5"
}
const _hoisted_3 = { class: "main-content" }
const _hoisted_4 = { class: "preview-card" }
const _hoisted_5 = { class: "app-header" }
const _hoisted_6 = { class: "app-image" }
const _hoisted_7 = { class: "app-info" }
const _hoisted_8 = { class: "app-description" }
const _hoisted_9 = { class: "app-buttons" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Install ")
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "btn-gradient rounded-pill",
  disabled: ""
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-check fa-fw me-1" }, null, -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Installed ")
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Screenshots", -1))
const _hoisted_19 = {
  key: 0,
  class: "screenshots-grid"
}
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"screenshot\" data-v-3ebf02a1><img src=\"" + _imports_1 + "\" alt=\"Screenshot 1\" data-v-3ebf02a1></div><div class=\"screenshot\" data-v-3ebf02a1><img src=\"" + _imports_2 + "\" alt=\"Screenshot 2\" data-v-3ebf02a1></div><div class=\"screenshot\" data-v-3ebf02a1><img src=\"" + _imports_3 + "\" alt=\"Screenshot 3\" data-v-3ebf02a1></div>", 3)
const _hoisted_23 = [
  _hoisted_20
]
const _hoisted_24 = {
  key: 1,
  class: "screenshots-grid"
}
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<div class=\"screenshot\" data-v-3ebf02a1><img src=\"" + _imports_4 + "\" alt=\"Screenshot 1\" data-v-3ebf02a1></div><div class=\"screenshot\" data-v-3ebf02a1><img src=\"" + _imports_5 + "\" alt=\"Screenshot 2\" data-v-3ebf02a1></div><div class=\"screenshot\" data-v-3ebf02a1><img src=\"" + _imports_6 + "\" alt=\"Screenshot 3\" data-v-3ebf02a1></div>", 3)
const _hoisted_28 = [
  _hoisted_25
]
const _hoisted_29 = {
  key: 2,
  class: "screenshots-grid"
}
const _hoisted_30 = /*#__PURE__*/_createStaticVNode("<div class=\"screenshot\" data-v-3ebf02a1><img src=\"" + _imports_7 + "\" alt=\"Screenshot 1\" data-v-3ebf02a1></div><div class=\"screenshot\" data-v-3ebf02a1><img src=\"" + _imports_8 + "\" alt=\"Screenshot 2\" data-v-3ebf02a1></div><div class=\"screenshot\" data-v-3ebf02a1><img src=\"" + _imports_9 + "\" alt=\"Screenshot 3\" data-v-3ebf02a1></div>", 3)
const _hoisted_33 = [
  _hoisted_30
]
const _hoisted_34 = { class: "description" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = /*#__PURE__*/_createStaticVNode("<h3 data-v-3ebf02a1>Asset Preview – Instantly View Creative Files in Sprinklr</h3><p data-v-3ebf02a1> Before, previewing creative files like PSD meant downloading and opening them in specialized software—slowing down your team. Now, with our PowerUp, you can preview all your creative files—directly in your Sprinklr library. No downloads. No extra tools. <br data-v-3ebf02a1><br data-v-3ebf02a1><strong data-v-3ebf02a1>How it works:</strong> One-click installation. The app runs automatically in the background—every time someone uploads a design file, it generates a preview instantly. Zero configuration needed. <br data-v-3ebf02a1><br data-v-3ebf02a1><strong data-v-3ebf02a1>Why you need it:</strong> Your team wastes hours downloading files just to see what&#39;s inside them. This creates bottlenecks in approval workflows and slows down campaign launches. Asset Preview eliminates that friction entirely. <br data-v-3ebf02a1><br data-v-3ebf02a1>Now your team can: </p><ul data-v-3ebf02a1><li data-v-3ebf02a1>Review and approve creative work without leaving Sprinklr</li><li data-v-3ebf02a1>Make faster decisions with visual context</li><li data-v-3ebf02a1>Avoid downloading the wrong files</li><li data-v-3ebf02a1>Keep projects moving at campaign speed</li></ul>", 3)
const _hoisted_39 = [
  _hoisted_36
]
const _hoisted_40 = { key: 1 }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Asset Unzip – Instantly Extract and Upload Creative Assets ", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Before, uploading ZIP files meant downloading, extracting, and manually sorting each asset—slowing down your workflow. Now, with our PowerUp, every ZIP file you upload into Sprinklr digital asset manager is automatically unzipped and organized in your library using correct tags based on your folder structure and file naming conventions. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" For example:"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Let’s say you create a ZIP file with folders for 5 different regions, each containing localized assets. The PowerUp will extract every asset automatically tagging each one with the correct region (based on the folder name) & applying any other details from the asset name itself. Result: All your assets are immediately searchable, organized, and ready for use in Sprinklr library—no manual tagging required. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("strong", null, "How it works:"),
  /*#__PURE__*/_createTextVNode(" After installing the app, you’ll need to set up the mapping of values tailored to your organization’s needs. This collaborative setup ensures your assets are handled, tagged, and organized exactly as required for your unique campaigns and processes. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("strong", null, "Why you need it:"),
  /*#__PURE__*/_createTextVNode(" Eliminate tedious manual uploads and sorting—your team stays focused on creative work. ")
], -1))
const _hoisted_43 = [
  _hoisted_41,
  _hoisted_42
]
const _hoisted_44 = { key: 2 }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Image Crop – Auto Crop & Resize Images", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Before, cropping and resizing images meant opening each file in design software and adjusting them manually—taking up valuable time and risking inconsistency. Now, with our PowerUp, your images are automatically cropped and resized by AI the moment they’re uploaded to Sprinklr. No manual edits. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("strong", null, "How it works:"),
  /*#__PURE__*/_createTextVNode(" Install with one click. Set your own rules in the Raffish PowerUp store—for example, choose your crop ratio and target image size. You can also add a custom property: just define the field name and its value (for example, “Orientation: Landscape”). Each new image will be automatically tagged with this custom property as a key-value pair, making it easier to organize and find your assets later. To enable this feature, make sure to set the related Action in your workflow. Then, let the app run automatically in the background—every time someone uploads an image, it’s instantly cropped and resized to your specifications. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("strong", null, "Why you need it:"),
  /*#__PURE__*/_createTextVNode(" Guarantee every image is on-brand and campaign-ready—without the manual effort. Keep your visuals perfectly sized and framed across all channels—no more time wasted on manual edits. ")
], -1))
const _hoisted_47 = [
  _hoisted_45,
  _hoisted_46
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.app)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("section", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", {
                    class: _normalizeClass([_ctx.app.icon, "fa-2x"])
                  }, null, 2)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("h1", null, _toDisplayString(_ctx.app.title), 1),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.app.short_description), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  (_ctx.installable(this.appName))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn-gradient rounded-pill",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.installApp()))
                      }, _hoisted_12))
                    : (_openBlock(), _createElementBlock("button", _hoisted_13, _hoisted_16))
                ])
              ]),
              _hoisted_17,
              _hoisted_18,
              (_ctx.appName === 'image-crop-resize')
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_23))
                : _createCommentVNode("", true),
              (_ctx.appName === 'asset-unzip')
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_28))
                : _createCommentVNode("", true),
              (_ctx.appName === 'asset-preview')
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_33))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_34, [
                (_ctx.appName === 'asset-preview')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, _hoisted_39))
                  : _createCommentVNode("", true),
                (_ctx.appName === 'asset-unzip')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, _hoisted_43))
                  : _createCommentVNode("", true),
                (_ctx.appName === 'image-crop-resize')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, _hoisted_47))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createVNode(_component_router_view)
        ]))
      : _createCommentVNode("", true)
  ]))
}